import React from 'react';
import { useNavigate, useParams, BrowserRouter } from 'react-router-dom';
import { ArrowLeft, CreditCard, CheckCircle2 } from 'lucide-react';

function PagoExpressContent() {
    const navigate = useNavigate();
    const { aid } = useParams();

    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-600 flex items-center justify-center p-6">
            <div className="w-full max-w-2xl bg-white rounded-3xl shadow-xl p-8 lg:p-12 border border-slate-100">

                <button
                    onClick={() => navigate('/login')}
                    className="flex items-center gap-2 text-sky-600 font-bold mb-8 hover:underline"
                >
                    <ArrowLeft size={20} /> Volver
                </button>

                <div className="text-center mb-10">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-emerald-100 rounded-full text-emerald-600 mb-6">
                        <CreditCard size={40} />
                    </div>
                    <h1 className="text-3xl font-black text-slate-800">Pago Express</h1>
                    <p className="text-slate-500 mt-2 text-lg">
                        Mostrando deuda para cliente N° <span className="font-bold text-slate-800">{aid}</span>
                    </p>
                </div>

                {/* Simulación de deuda */}
                <div className="bg-sky-50 border border-sky-100 rounded-2xl p-6 mb-8 flex items-center justify-between">
                    <div>
                        <p className="text-sm font-bold text-sky-800 uppercase tracking-wider">Total a Pagar</p>
                        <p className="text-4xl font-black text-slate-800">$24.500</p>
                    </div>
                    <div className="bg-white px-4 py-2 rounded-lg shadow-sm">
             <span className="text-sm font-bold text-emerald-600 flex items-center gap-2">
                <CheckCircle2 size={16} /> Deuda Vencida
             </span>
                    </div>
                </div>

                <button className="w-full py-4 rounded-xl bg-sky-600 text-white font-bold text-lg shadow-lg shadow-sky-200 hover:bg-sky-700 hover:scale-[1.01] transition-all">
                    Confirmar y Pagar
                </button>

            </div>
        </div>
    );
}

export default PagoExpressContent;
